var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-segment",style:(Object.assign(_vm._toCSSLine(_vm.start, _vm.end), {
    background: _vm.color
  }))})
}
var staticRenderFns = []

export { render, staticRenderFns }